<template>
  <hm-content title="" class="diy-loading">
    <!-- <div class="pivot-table" v-if="false">
      <pivot-table
        showSettingsText="显示设置"
        hideSettingsText="隐藏设置"
        :colFieldKeys="colFieldKeys"
        :rowFieldKeys="rowFieldKeys"
        available-fields-label-text="可用字段的文本拖动区域区域"
        cols-label-text="列拖动区域区域的文本"
        rowsLabelText="可用字段Rows"
        :data="asyncData"
        :fields="fields"
        :row-fields="rowFields"
        :col-fields="colFields"
        :reducer="reducer"
      >
        <template v-slot:computing>
          <div
            class="position-absolute w-100 h-100 text-center"
            style="z-index: 1"
          >
            <div
              class="position-sticky bg-white d-inline-block mt-5 p-3"
              style="top: 0"
            >
              Loading table values...
            </div>
          </div>
        </template>
      </pivot-table>
    </div> -->
    <div v-show="!show">
      <br />
      <el-popover
        placement="bottom-end"
        trigger="hover"
        content="收藏常用报表样式。"
      >
        <div
          slot="reference"
          class="box pointer"
          :class="{
            'is-boxactive': isAct,
          }"
          @click="collection"
        ></div>
      </el-popover>
      <div>当前报表：{{ row.reportName }}</div>
      <div
        class="expand_search"
        v-if="!searchListVisbale"
        @click="showSearchToggle"
      >
        展开查询条件<span class="hmicon icon-xiashuangjiantou"></span>
      </div>
      <div class="flex flex-wrap item-center p10" v-else>
        <div class="flex item-center flex-wrap">
          <div v-for="(v, i) in searchList" :key="i">
            <div class="flex item-center mb10">
              <span
                v-if="v.isRequiredWhere === 'yes'"
                class="danger hmicon icon-xinghao"
              >
              </span>
              <template v-if="v.columnType === 'datetime'">
                <el-date-picker
                  @focus="datefocus(i, v)"
                  @blur="dateblur(i, v)"
                  @change="datechange(i, v)"
                  v-if="v.queryMode === 'range'"
                  v-model="v.applyDate"
                  type="daterange"
                  align="right"
                  style="width: 212px"
                  :default-time="['00:00:00', '23:59:59']"
                  :start-placeholder="v.labelName"
                  :end-placeholder="v.labelName"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  size="small"
                  class="mr10"
                  clearable
                  :picker-options="pickerOptions"
                ></el-date-picker>

                <template v-else>
                  <el-date-picker
                    clearable
                    class="mr10"
                    @focus="datefocus(i, v)"
                    @blur="dateblur(i, v)"
                    @change="datechange(i, v)"
                    style="width: 200px"
                    v-if="v.columnType === 'datetime'"
                    v-model="v.queryValue"
                    type="date"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    size="small"
                    :placeholder="v.labelName"
                  >
                  </el-date-picker>
                </template>
                <el-tooltip class="item" effect="dark" placement="right">
                  <div slot="content">
                    {{ v.labelName
                    }}{{ v.isRequiredWhere === "yes" ? "(必填)" : "" }}
                  </div>
                  <i class="el-icon-info mr20"></i>
                </el-tooltip>
              </template>
              <template v-else-if="v.columnType === 'date'">
                <el-date-picker
                  v-model="v.applyDate"
                  type="daterange"
                  class="mr10"
                  value-format="yyyy-MM-dd"
                  :start-placeholder="v.labelName"
                  :end-placeholder="v.labelName"
                  size="small"
                >
                </el-date-picker>
              </template>
              <template v-else>
                <!-- {{ v.labelName }} -->
                <el-select
                  clearable
                  v-if="v.isSelect && v.isMultiple"
                  size="small"
                  style="width: 200px"
                  :placeholder="v.labelName"
                  v-model="v.queryListValue"
                  :multiple="v.isMultiple"
                  @change="datechange(i, v)"
                >
                  <el-option
                    v-for="(v, i) in v.selectList"
                    :key="i"
                    :label="v.text"
                    :value="v.value"
                  ></el-option>
                </el-select>
                <el-select
                  clearable
                  v-if="v.isSelect && !v.isMultiple"
                  size="small"
                  style="width: 200px"
                  :placeholder="v.labelName"
                  v-model="v.queryValue"
                  :multiple="v.isMultiple"
                  @change="datechange(i, v)"
                >
                  <el-option
                    v-for="(v, i) in v.selectList"
                    :key="i"
                    :label="v.text"
                    :value="v.value"
                  ></el-option>
                </el-select>
                <template v-if="v.queryMode === 'range'">
                  <el-input
                    style="width: 90px"
                    size="small"
                    clearable
                    class="ipt"
                    @blur="datechange(i, v)"
                    @focus="datechange(i, v)"
                    @change="datechange(i, v)"
                    v-model.trim="v.queryStartValue"
                    :placeholder="v.labelName"
                  ></el-input>
                  <el-input
                    style="width: 90px"
                    size="small"
                    clearable
                    class="ipt"
                    @blur="datechange(i, v)"
                    @focus="datechange(i, v)"
                    @change="datechange(i, v)"
                    v-model.trim="v.queryEndValue"
                    :placeholder="v.labelName"
                  ></el-input>
                </template>

                <el-input
                  v-if="v.queryMode === 'equal' || v.queryMode === 'like'"
                  style="width: 200px"
                  size="small"
                  clearable
                  class="ipt"
                  @blur="datechange(i, v)"
                  @focus="datechange(i, v)"
                  @change="datechange(i, v)"
                  v-model.trim="v.queryValue"
                  :placeholder="v.labelName"
                ></el-input>
                <el-tooltip class="item" effect="dark" placement="right">
                  <div slot="content">
                    {{ v.labelName
                    }}{{ v.isRequiredWhere === "yes" ? "(必填)" : "" }}
                  </div>
                  <i class="el-icon-info mr20"></i>
                </el-tooltip>
              </template>
            </div>
          </div>
        </div>

        <el-button
            :disabled="generateVisiable"
          style="height: 32px"
          type="primary"
          size="small"
          @click="search"
          :loading="loading"
          >生成报表</el-button
        >
        <el-button
          style="height: 32px"
          type="primary"
          size="small"
          @click="detailsReports"
          :loading="loading"
          >查看已生成报表</el-button
        >
        <el-button
          style="height: 32px"
          type="primary"
          size="small"
          @click="filterDialog = true"
          :loading="loading"
          >过滤</el-button
        >
        <!-- <el-button
          style="height: 32px; backgroud-color: #0081e5"
          type="blue"
          size="small"
          @click="exchange"
          :loading="loading"
          >交换列</el-button> -->
        <el-button
          style="height: 32px; backgroud-color: #0081e5"
          type="blue"
          size="small"
          @click="showSearchToggle"
          >隐藏查询条件</el-button
        >
      </div>
      <div class="form-item-tip ml10">请从已生成报表中导出您需要导出的报表</div>

      <div class="flex flex-between">
        <div class="form-red">
          当前列表只展示200条数据，如需查看完整数据请导出表
        </div>
        <div>
          <!-- <el-button type="text" class="mr10" size="small" @click="gopivot"
            >透视表</el-button
          > -->
          <!-- <el-button type="text" class="mr10" size="small"  @click="tableSetToggle">表头配置</el-button>
          <el-checkbox-group v-model="table_options" v-if="tableSetVisible" @change="tableChange">
            <el-checkbox :label="v.labelName" v-for="(v,i) in tableHeader" :key="i">{{v.labelName}}</el-checkbox>
          </el-checkbox-group> -->
        </div>
      </div>

      <div class="hm-table-darg">
        <!-- <div class="flex item-center seacrch-list display" >
          <i class="el-icon-search"/>
          <div
            v-for="(item, index) in tableHeader"
            :key="index"
          >
          {{item.filterPlacement}}
            <el-input
              v-if="item.filterPlacement&&item.filterPlacement!==''"
              style="width:100px"
              size="small"
              clearable
              class="mr10 ipt"
              v-model.trim="item.gameName"
            ></el-input>
          </div>
        </div> -->

        <draggable
          class="list-group-none flex flex-warp"
          :list="tableHeader"
          group="people"
        >
          <div
            style="width: 280px"
            class="flex flex-wrap text-center"
            v-for="(item, index) in tableHeader"
            :key="index"
          >
            {{ item.labelName }}
          </div>
        </draggable>
        <hm-table
          @delHeader="delHeader"
          @dragHeader="changeHeader"
          :data="tableDatas"
          :header="tableHeader"
          :option="tableOption"
          :loading="loading"
          :xiaoji="tableXiaoji"
          bgColor="#F7F7F7"
          ref="hmtable"
        >
          <el-table-column
            slot="fixed"
            fixed
            label="序号"
            width="50"
            type="index"
          >
          </el-table-column>
        </hm-table>
        <div
          class="table-options flex flex-center item-center"
          @click="tableSetVisible = true"
        >
          <span class="table-options-text">表头配置</span>
          <span class="hmicon icon-icon-youjiantou"></span>
        </div>
        <!-- 添加表头配置弹窗 -->
        <div class="table-set-popup" v-if="tableSetVisible" title="添加表头">
          <div class="table-set-tit">添加表头</div>
          <div
            class="table-set-close hmicon icon-guanbi1"
            @click="tableSetVisible = false"
          ></div>
          <el-checkbox-group v-model="table_options" @change="tableChange">
            <el-checkbox
              v-model="v.isShow"
              style="display: block; margin-bottom: 20px"
              :label="v.labelName"
              v-for="(v, i) in tableHeader"
              :key="i"
              >{{ v.labelName }}
            </el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      title="已生成报表"
      width="80%"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
    >
      <div class="table">
        <div class="form-red">
          由于生成报表数据量过大，可能存在一定延时，请稍后进行查看。
        </div>
        <el-table
          stripe
          :data="reportsList"
          style="width: 100%"
          id="table"
          size="small"
          border
          :max-height="400"
        >
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="序号"
            width="50"
            :index="(index) => index + (currentPage - 1) * pageSize + 1"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="reportName"
            label="报表名称"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="header"
            label="报表表头"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="schedulingTime"
            label="生成报表时间"
          ></el-table-column>
          <el-table-column header-align="center" align="center" label="操作">
            <template slot-scope="scope">
              <div class="flex flex-center">
                <el-button size="small" type="text" @click="detail(scope.row)"
                  >查看</el-button
                >
                <el-button size="small" type="text" @click="save(scope.row)"
                  >导出</el-button
                >
                <el-button size="small" type="text" @click="del(scope.row)"
                  >删除</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- <div class="text-center">
        <el-pagination
          background
          layout="total,sizes,  prev, pager, next, jumper"
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          :current-page="currentPage"
        ></el-pagination>
      </div> -->
      </div>
      <span slot="footer" class="flex flex-center">
        <el-button size="small" @click="handleClose">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 添加表头配置弹窗 -->
    <!-- <el-dialog
      append-to-body
      :visible.sync="tableSetVisible"
      @close="tableSetVisible = false"
      width="266px"
      title="添加表头"
    >
      <el-checkbox-group v-model="table_options" @change="tableChange">
        <el-checkbox
          v-model="v.isShow"
          style="display: block"
          :label="v.labelName"
          v-for="(v, i) in tableHeader"
          :key="i"
          >{{ v.labelName }}
        </el-checkbox>
      </el-checkbox-group>
    </el-dialog> -->
    <!-- <el-dialog
      :close-on-click-modal="false"
      title="已生成报表"
      width="80%"
      :visible.sync="pivotTableVisible"
      :before-close="handleClosePivotTable"
    >
      <div class="pivot-table" v-if="pivotTableVisible">
        <pivot-table
          showSettingsText="显示设置"
          hideSettingsText="隐藏设置"
          :colFieldKeys="colFieldKeys"
          :rowFieldKeys="rowFieldKeys"
          available-fields-label-text="未选中字段区域（可拖拽）"
          cols-label-text="列区域（可拖拽）"
          rowsLabelText="行区域（可拖拽）"
          :data="asyncData"
          :fields="fields"
          :row-fields="rowFields"
          :col-fields="colFields"
          :reducer="reducer"
        >
          <template v-slot:computing>
            <div
              class="position-absolute w-100 h-100 text-center"
              style="z-index: 1"
            >
              <div
                class="position-sticky bg-white d-inline-block mt-5 p-3"
                style="top: 0"
              >
                Loading table values...
              </div>
            </div>
          </template>
        </pivot-table>
      </div>
    </el-dialog> -->
    <!-- 收藏夹提示 -->
    <!-- <el-dialog
      title="提示"
      :visible.sync="bookmarksDialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <span>按下 Ctrl+D 即可收藏网址</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="bookmarksDialogVisible = false"
          >确定</el-button
        >
      </span>
    </el-dialog> -->
    <div @click="isShow" v-if="show">
      <img
        style="min-width: calc(100vh - 165px); position: relative"
        src="https://imgcdn.hemiao100.com/ThemePictures/20200929113622.png"
        alt="xx"
      />
      <img
        style="
          position: absolute;
          top: 128px;
          left: 713px;
          width: 400px;
          zindex: 2022;
        "
        src="https://imgcdn.hemiao100.com/ThemePictures/22222.png"
        alt="zz"
      />
      <img
        style="
          position: absolute;
          top: 3px;
          left: 393px;
          width: 341px;
          zindex: 2022;
        "
        src="https://imgcdn.hemiao100.com/ThemePictures/33333.png"
        alt="zz"
      />
      <img
        style="
          position: absolute;
          top: 300px;
          left: 600px;
          width: 128px;
          zindex: 2022;
        "
        class="pointer"
        src="https://imgcdn.hemiao100.com/ThemePictures/%E7%9F%A5%E9%81%93%E4%BA%86%402x.png"
        alt="zz"
      />
    </div>
    <div
      class="v-modal el-dialog__wrapper shadow"
      style="zindex: 2021"
      @click="isShow"
      v-if="show"
    ></div>
    <!-- 过滤弹窗 -->
    <el-dialog
      append-to-body
      :visible.sync="filterDialog"
      @close="filterDialog = false"
      width="800px"
      title="过滤设置"
    >
      <div>
        <div
          class="flex flex-start item-center mb10"
          v-for="(v, i) in filterArr"
          :key="i"
        >
          <el-select v-model="v.column" placeholder="请选择字段">
            <el-option
              v-for="item in tableHeader"
              :key="item.columnName"
              :label="item.labelName"
              :value="item.columnName"
            >
            </el-option>
          </el-select>
          <el-input
            clearable
            style="width: 300px"
            v-model.trim="v.value"
            placeholder="请输入字段值"
            size="small"
            class="ipt ml20 mr20"
          ></el-input>
          <span class="hmicon icon-jiahao mr10" @click="filterAdd(i)"></span>
          <span
            class="hmicon icon-jianhao1"
            @click="filterDel(i)"
            v-if="filterArr.length > 1"
          ></span>
        </div>
        <div class="flex flex-center item-center mt20">
          <el-button size="small" type="primary" @click="filter"
            >查询</el-button
          >
          <el-button size="small" type="info" @click="filterDialog = false"
            >取消</el-button
          >
        </div>
      </div>
    </el-dialog>
  </hm-content>
</template>

<script>
import Sortable from "sortablejs";
import HmTable from "@/components/HmTable";
import { getSubtract, arrayUnique2, getDayAndToday } from "@/utils/utils";
import draggable from "vuedraggable";
// import PivotTable from "@marketconnect/vue-pivot-table";
import axios from "axios";

export default {
  components: {
    HmTable,
    draggable,
    // PivotTable
  },
  data() {
    return {
      // 过滤弹窗
      filterDialog: false,
      queueId: "",
      total: 0,
      currentPage: 1,
      pageSize: 10,
      show: true,
      pivotTableVisible: false,
      searchListVisbale: true,
      tableSetVisible: false,
      // bookmarksDialogVisible:false,
      rowFields: [
        // {
        //   getter: item => item.country,
        //   label: "Country"
        //   // headerSlotNames: ["countryFlagHeader", "countryNameHeader"]
        // },
        // {
        //   getter: item => item.gender,
        //   label: "Gender"
        //   // headerSlotName: "genderHeader"
        // }
      ],
      colFields: [
        {
          getter: (item) => item.year,
          label: "Year",
        },
      ],
      reducer: (sum, item) => {
        return sum + item.count;
      },
      rowFieldKeys: ["country", "gender"],
      colFieldKeys: ["year"],
      fields: [
        {
          key: "country",
          getter: (item) => item.country,
          label: "Country",
          // headers: [
          //   {
          //     slotName: "countryFlagHeader",
          //     label: "Flag",
          //     checked: true
          //   },
          //   {
          //     slotName: "countryNameHeader",
          //     label: "Name",
          //     checked: true
          //   }
          // ],
          // headerAttributeFilter: true,
          // valueFilter: true
        },
        {
          key: "gender",
          getter: (item) => item.gender,
          label: "Gender",
          // headerSlotName: "genderHeader",
          // valueFilter: true
          // valueFilterSlotName: "genderHeader"
        },
        {
          key: "year",
          getter: (item) => item.year,
          label: "Year",
          valueFilter: true,
        },
      ],
      asyncData: [
        {
          country: "United States",
          year: 2010,
          gender: "male",
          count: 153295220,
        },
        {
          country: "United States",
          year: 2010,
          gender: "female",
          count: 156588400,
        },
        {
          country: "United States",
          year: 2011,
          gender: "male",
          count: 154591960,
        },
        {
          country: "United States",
          year: 2011,
          gender: "female",
          count: 157800200,
        },
        {
          country: "United States",
          year: 2012,
          gender: "male",
          count: 155851840,
        },
        {
          country: "United States",
          year: 2012,
          gender: "female",
          count: 158944800,
        },
        { country: "China", year: 2010, gender: "male", count: 690256342 },
        { country: "China", year: 2010, gender: "female", count: 650712406 },
        { country: "China", year: 2011, gender: "male", count: 694106441 },
        { country: "China", year: 2011, gender: "female", count: 654068030 },
        { country: "China", year: 2012, gender: "male", count: 697964288 },
        { country: "China", year: 2012, gender: "female", count: 657422649 },
        { country: "India", year: 2010, gender: "male", count: 638354751 },
        { country: "India", year: 2010, gender: "female", count: 592629727 },
        { country: "India", year: 2011, gender: "male", count: 646873890 },
        { country: "India", year: 2011, gender: "female", count: 600572093 },
        { country: "India", year: 2012, gender: "male", count: 655193693 },
        { country: "India", year: 2012, gender: "female", count: 608395922 },
        { country: "France", year: 2010, gender: "male", count: 30675773 },
        { country: "France", year: 2010, gender: "female", count: 32285363 },
        { country: "France", year: 2011, gender: "male", count: 30815839 },
        { country: "France", year: 2011, gender: "female", count: 32452566 },
        { country: "France", year: 2012, gender: "male", count: 30948916 },
        { country: "France", year: 2012, gender: "female", count: 32612882 },
        { country: "Australia", year: 2010, gender: "male", count: 11124254 },
        { country: "Australia", year: 2010, gender: "female", count: 11218144 },
        { country: "Australia", year: 2011, gender: "male", count: 11260747 },
        { country: "Australia", year: 2011, gender: "female", count: 11359807 },
        { country: "Australia", year: 2012, gender: "male", count: 11280804 },
        { country: "Australia", year: 2012, gender: "female", count: 11402769 },
      ],

      reportsList: [],
      dialogVisible: false,
      tableOption: {
        border: true,
        // height: 500,
        height: 540,
        maxHeight: 550,
      },
      tableHeader: [],
      tableDatas: [],
      selectDate: "",
      //日期选择范围在一个月内
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.selectDate = minDate.getTime();
          if (maxDate) {
            this.selectDate = "";
          }
        },
        disabledDate: (time) => {
          if (this.selectDate !== "") {
            const one = this.days * 24 * 3600 * 1000;
            const minTime = this.selectDate - one;
            const maxTime = this.selectDate + one;
            return time.getTime() < minTime || time.getTime() > maxTime;
          }
        },
      },
      days: 30,
      id: this.$route.query.id,
      activeName: "second",
      searchList: [],
      isCollapse: false,
      activeIndex: "1",
      coypColList: [],
      col: [
        {
          labelName: "日期",
          columnName: "date",
        },
        {
          labelName: "姓名",
          columnName: "name",
        },
        {
          labelName: "地址",
          columnName: "address",
        },
      ],
      dropCol: [
        {
          labelName: "日期",
          columnName: "date",
        },
        {
          labelName: "姓名",
          columnName: "name",
        },
        {
          labelName: "地址",
          columnName: "address",
        },
      ],
      tableData: [],
      copyTableData: [],
      tableGroup: [],
      tableList: [],
      loading: false,
      searchTip: "",
      tableHeaderTip: "",
      tableOperationTip: "",
      isAct: false,
      resultId: "",
      isOutputing: false,
      row: {
        reportName: this.$route.query.reportName,
      },
      interval: null,
      generateVisiable: false,
      rows: {},
      // 表头配置
      table_options: [],
      tableSetVisible: false,
      // 需要小记的表头
      tableXiaoji: [],
      // 过滤数组
      filterArr: [{ column: "", value: "" }],
      // 过滤字段为空验证
      isValid: true,
    };
  },
  computed: {
    dragOptions() {
      return {
        animation: 0,
        group: "people",
        ghostClass: "ghost",
        disabled: this.loading,
      };
    },
  },
  watch: {
    col(val) {
      this.coypColList.forEach((v) => {
        if (val.findIndex((o) => o.id === v.id) > -1) {
          v.show = true;
        } else {
          v.show = false;
        }
      });
    },
  },
  created() {},
  mounted() {
    // this.columnDrop();
    this.quertTip();
    this.queryList().then(() => {
      this.queryHeader();
    });
    this.querySysCollectionDel();
    this.getParamsCookie();
    // test
    setTimeout(() => {
      // console.log(this.tableHeader);
      // this.tableHeader.forEach(v=>{
      //   v.isShow = true
      // })
      // this.table_options = this.tableHeader.map(v=>v.labelName)
      // console.log("this.tableHeader")
      // console.log(this.tableHeader)
    }, 2000);
  },
  destroyed() {
    this.interval = true;
    // clearInterval(interval);
  },
  methods: {
    save(row) {
      this.rows = row;
      axios({
        method: "post",
        url:
          this.$serverAdress +
          `/sys/common/download?filePath=${row.responseResultPath}`,
        responseType: "arraybuffer",
      }).then((res) => {
        this.download(res.data);
      });
    },
    download(data) {
      if (!data) {
        return;
      }
      let blob = new Blob([data], { type: "application/octet-stream" });
      let url = window.URL.createObjectURL(blob);
      let link = document.createElement("a");
      link.style.display = "none";
      link.href = url;
      link.setAttribute("download", this.rows.fileName);
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url); //释放掉blob对象
    },
    paging(page) {
      this.currentPage = page;
      this.detailsReports();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.detailsReports();
    },
    getParamsCookie() {
      const prams = localStorage.getItem("isShowGuidance");

      if (prams) {
        this.show = false;
      }
    },
    setParamsCookie() {
      localStorage.setItem(
        "isShowGuidance",
        JSON.stringify({ show: this.show })
      );
    },
    isShow() {
      this.show = false;
      this.setParamsCookie();
    },
    tableHeaderInit() {
      console.log(this.tableHeader);
      this.tableHeader.forEach((v) => {
        v.isShow = true;
      });
      this.table_options = this.tableHeader.map((v) => v.labelName);
      console.log("this.tableHeader");
      console.log(this.tableHeader);
    },
    // gopivot() {
    //   this.rowFields = [];
    //   this.colFields = [];
    //   this.rowFieldKeys = [];
    //   this.fields = [];
    //   this.colFieldKeys = [];

    //   this.asyncData = this.tableDatas;

    //   this.tableHeader.forEach(v => {
    //     this.rowFields.push({
    //       getter: item => item[v.columnName],
    //       label: v.labelName
    //     });
    //     this.rowFieldKeys.push(v.columnName);
    //     this.fields.push({
    //       key: v.columnName,
    //       getter: item => item[v.columnName],
    //       label: v.labelName
    //     });
    //     if (v.isAggregateColumn === "yes") {
    //       this.reducer = (sum, item) => {
    //         return sum + item[v.columnName];
    //       };
    //     } else {
    //       this.reducer = sum => {
    //         return sum + 1;
    //       };
    //     }
    //     // this.colFields = [
    //     //   {
    //     //     getter: item => item[v.columnName],
    //     //     label: v.labelName
    //     //   }
    //     // ];
    //   });
    //   // this.reducer = (sum, item) => {
    //   //   return sum + item.count;
    //   // };

    //   this.pivotTableVisible = true;

    //   // this.$router.push({
    //   //   name: "DataPivotTable"
    //   // });
    // },
    async del(row) {
      const result = await this.$confirm("删除本行数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      });

      if (result === "confirm") {
        const { code } = await this.$store.dispatch("delSysSchedulingRecord", {
          id: row.queueId,
        });
        if (code === "0") {
          this.$message({
            message: " 操作成功",
            type: "success",
          });
          this.detailsReports();
        }
      }
    },
    detail(row) {
      this.details(row, true);
    },
    details(row, cycle) {
      // Object.assign(this.row, row);
      // this.row = row;
      // console.log("this.row: ", this.row);
      console.log("rowwwwww");
      this.$store
        .dispatch("querySsrAnalysisQueueDetail", {
          queueId: row.queueId,
        })
        .then((res) => {
          const code = res.code;
          const result = res.result;
          if (code === "0") {
            if (cycle) {
              this.dialogVisible = false;
            }
            if (
              result.processStatus === "fail" ||
              result.processStatus === "succ"
            ) {
              this.interval = true;
              this.generateVisiable = false;
            }
            if (result.processStatus === "wait") {
              this.generateVisiable = true;
            }

            this.tableList = JSON.parse(result.tableHeader).AllHeader;

            // console.log(JSON.parse(result.tableHeader).tableHeader);
            this.tableHeader = JSON.parse(result.tableHeader).tableHeader;

            console.log("tableXiaoji", this.tableXiaoji);

            this.searchList = JSON.parse(result.queryCondition);
            if (result.responseResultContent) {
              this.tableDatas = JSON.parse(result.responseResultContent);

              // this.tableDatas = this.tableDatas.slice(0, 200);
              this.copyTableDatas = JSON.parse(
                JSON.parse(JSON.stringify(result.responseResultContent))
              );
            }

            if (row.reportId !== this.id) {
              this.$route.query.id = row.reportId;
              this.id = row.reportId;
              this.querySysCollectionDel();
            }
          } else {
            console.log(code);
            // -1
            this.interval = null;
          }
        }).catch(res=>{
          console.log(res.code);
          // -1
          this.interval = "";
        });
    },
    handleClosePivotTable() {
      this.pivotTableVisible = false;
      // this.rowFields = [];
      // this.colFields = [];
      // this.rowFieldKeys = [];
      // this.fields = [
      //   {
      //     key: "country",
      //     getter: item => item.country,
      //     label: "Country"
      //   },
      //   {
      //     key: "gender",
      //     getter: item => item.gender,
      //     label: "Gender"
      //   },
      //   {
      //     key: "year",
      //     getter: item => item.year,
      //     label: "Year",
      //     valueFilter: true
      //   }
      // ];
      // this.colFieldKeys = [];
      // this.reducer = (sum, item) => {
      //   return sum + 1;
      // };
    },
    handleClose() {
      this.dialogVisible = false;
    },
    // 交换列
    // exchange() {
    //   console.log(this.tableHeader);
    //   let arr = [...this.tableHeader];
    //   // let temp = arr[3]
    //   // arr[3] = arr[0]
    //   // arr[0] = temp
    //   arr.splice(3, 1);
    //   arr.unshift(arr[3]);
    //   console.log(arr);
    //   this.tableHeader = arr;
    //   this.$refs.hmtable.tableHeader = this.tableHeader;
    // },
    // 表头配置弹窗
    tableSetToggle() {
      this.tableSetVisible = !this.tableSetVisible;
    },
    // 选择表头
    tableChange(e) {
      console.log(e);
      const arr = e;
      this.tableHeader.forEach((v) => {
        if (arr.includes(v.labelName)) {
          v.isShow = true;
        } else {
          v.isShow = false;
        }
      });
      console.log(this.tableHeader);
      this.queryNotHeader();
      this.$forceUpdate();
    },
    async detailsReports() {
      this.dialogVisible = true;
      let params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
      };
      const { result } = await this.$store.dispatch(
        "queryNotUseSsrAnalysisQueue",
        params
      );
      if (result.length) {
        result.forEach((v) => {
          v.header = JSON.parse(v.tableHeader)
            .tableHeader.map((o) => o.labelName)
            .join(",");
        });
        this.reportsList = result;
      }
    },
    async querySysCollectionDel() {
      let params = {
        moduleType: "ssr",
        funcType: "reportsView",
        funcId: this.id,
      };
      const { result } = await this.$store.dispatch(
        "querySysCollectionDel",
        params
      );
      this.isAct = result;
    },
    collection() {
      this.sysCollection();
    },
    async sysCollection() {
      let params = {
        moduleType: "ssr",
        funcType: "reportsView",
        funcId: this.id,
      };
      let name = this.isAct ? "sysCollectionDel" : "sysCollection";
      const { code } = await this.$store.dispatch(name, params);
      if (code === "0") {
        this.isAct = !this.isAct;
      }
    },
    changeHeader(list) {
      this.tableHeader = list;
    },
    end() {
      this.$refs.hmtable.transitionShowTiem();
    },
    // 添加表头
    addHeader(item) {
      if (!this.loading) {
        this.$refs.hmtable.transitionShowTiem();
        setTimeout(() => {
          this.tableHeader.push(item);
          this.tableHeader = arrayUnique2(this.tableHeader, "id");
          this.queryNotHeader();
        }, 300);
      }
    },
    // 删除表头
    delHeader(list) {
      this.tableHeader = list;
      this.queryNotHeader();
    },
    add() {
      this.tableHeader.push({
        prop: "date",
        label: "日期",
        minWidth: "120",
      });
    },
    handleNameSort() {},
    translation(code, columnName) {
      if (columnName) {
        if (this.$sysAllDict[code].find((o) => o.value === columnName)) {
          return this.$sysAllDict[code].find((o) => o.value === columnName)
            .text;
        } else {
          return "";
        }
      } else {
        return "";
      }
    },
    async queryHeader() {
      const { result } = await this.$store.dispatch("queryHeader", {
        configId: this.id,
        layoutType: "pc",
      });
      if (result.records.length) {
        let list = JSON.parse(result.records[0].layoutComponents);

        // let col = [];
        // list.forEach(v => {
        //   let o = this.tableHeader.find(o => o.id === v.id);
        //   if (o) {
        //     if (
        //       v.isSelectColumn === o.isSelectColumn &&
        //       v.isGroupColumn === o.isGroupColumn &&
        //       v.isAggregateColumn === o.isAggregateColumn
        //     ) {
        //       col.push(v);
        //     } else {
        //       console.warn(v);
        //     }
        //   }
        // });
        // this.tableHeader = col;

        this.tableHeader = JSON.parse(JSON.stringify(list));
        // console.log("this.tableHeader", this.tableHeader);
        this.tableHeader.forEach((v) => {
          v.filterPlacement = "";
        });
        this.tableHeaderInit();
        this.queryNotHeader();
        this.tableData = [];
        this.$forceUpdate();
      }
    },
    async saveHeader() {
      if (this.tableHeader.length) {
        let params = {
          configId: this.id,
          layoutComponents: JSON.stringify(this.tableHeader),
          layoutType: "pc",
        };
        await this.$store.dispatch("saveHeader", params);
        // if (code === "0") {
        //   this.$message({
        //     message: "操作成功",
        //     type: "success"
        //   });
        // }
      } else {
        this.$message({
          message: "请先选择表头",
          type: "warning",
        });
      }
    },
    async quertTip() {
      const searchTip = await this.$store.dispatch("queryReportSearch");
      this.searchTip = searchTip.result;
      const tableHeaderTip = await this.$store.dispatch(
        "queryReportTableHeader"
      );
      this.tableHeaderTip = tableHeaderTip.result;
      const tableOperationTip = await this.$store.dispatch(
        "queryReportTableOperation"
      );
      this.tableOperationTip = tableOperationTip.result;
    },
    handleSelect(key) {
      if (this.activeName === "first") {
        if (
          this.searchList[key].queryMode === "range" &&
          this.searchList[key].columnType === "datetime"
        ) {
          this.days = +this.searchList[key].datetimeRangeLimit;
        }
      }
    },
    queryAnalyzeList() {
      let whereColumns = [];
      let selectColumns = [];
      let groupColumns = [];
      let falg = false;
      this.searchList.forEach((v) => {
        if (v.isRequiredWhere === "yes") {
          if (v.columnType === "datetime") {
            if (v.queryMode === "range") {
              if (v.applyDate === null || v.applyDate.length === 0) {
                falg = true;
              } else {
                whereColumns.push(v);
              }
            } else {
              if (v.queryValue === "") {
                falg = true;
              } else {
                whereColumns.push(v);
              }
            }
          } else if (v.columnType === "date") {
            if (v.applyDate === null || v.applyDate.length === 0) {
              falg = true;
            } else {
              whereColumns.push(v);
            }
          } else {
            if (v.isMultiple) {
              if (v.queryListValue.length === 0) {
                falg = true;
              } else {
                whereColumns.push(v);
              }
            } else {
              if (v.queryValue === "") {
                falg = true;
              } else {
                whereColumns.push(v);
              }
            }
          }
        } else {
          if (v.columnType === "datetime") {
            if (v.queryMode === "range") {
              if (v.applyDate === null || v.applyDate.length === 0) {
                // falg = false;
              } else {
                whereColumns.push(v);
              }
            } else {
              if (v.queryValue === "") {
                // falg = false;
              } else {
                whereColumns.push(v);
              }
            }
          } else if (v.columnType === "date") {
            if (v.applyDate === null || v.applyDate.length === 0) {
              // falg = false;
            } else {
              whereColumns.push(v);
            }
          } else {
            if (v.isMultiple) {
              if (v.queryListValue.length === 0) {
                // falg = false;
              } else {
                whereColumns.push(v);
              }
            } else {
              if (v.queryValue === "") {
                // falg = false;
              } else {
                whereColumns.push(v);
              }
            }
          }
        }
      });
      if (falg) {
        this.$message({
          message: "请填写完必填项",
          type: "warning",
        });
      } else {
        let show = false;
        this.col.forEach((v) => {
          if (v.isAggregateColumn === "yes") {
            show = true;
          }
        });
        if (show) {
          this.tableHeader.forEach((v) => {
            if (v.isAggregateColumn !== "yes") {
              groupColumns.push(v);
            }
          });
          selectColumns = JSON.parse(JSON.stringify(this.tableHeader));
        } else {
          selectColumns = JSON.parse(JSON.stringify(this.tableHeader));
          // this.col.forEach(v => {
          //   if (v.isSelectColumn === "yes") {
          //     selectColumns.push(v);
          //   }
          //   if (v.isGroupColumn === "yes") {
          //     groupColumns.push(v);
          //   }
          // });
        }

        // if (this.tableHeader === "table") {
        //   selectColumns = JSON.parse(JSON.stringify(this.col));
        //   groupColumns = [];
        // } else {
        //   groupColumns = JSON.parse(JSON.stringify(this.col));
        //   selectColumns = JSON.parse(JSON.stringify(this.tableGroup));
        // }

        // let selectColumns = JSON.parse(JSON.stringify(this.col));
        // let groupColumns = JSON.parse(JSON.stringify(this.col));
        whereColumns.forEach((v) => {
          if (v.queryMode === "range") {
            if (v.columnType === "datetime" || v.columnType === "date") {
              v.queryStartValue = v.applyDate[0];
              v.queryEndValue = v.applyDate[1];
            }
          }
        });
        // this.tableHeader
        // this.searchList
        let tableHeader = {
          tableHeader: this.tableHeader,
          AllHeader: this.tableList,
        };
        let params = {
          id: this.id,
          whereColumns,
          selectColumns,
          groupColumns,
          tableHeader: JSON.stringify(tableHeader),
          queryCondition: JSON.stringify(this.searchList),
          // returnDataMode: "sync",
        };
        this.loading = true;
        this.$store.dispatch("queryAnalyzeList", params).then((res) => {
          const { result, code } = res;
          if (code === "0") {
            this.saveHeader();
            this.loading = false;
            this.resultId = result;
            // 跟上面一样,便于过滤接口传参
            this.queueId = result;
            this.$message({
              message: "报表正在生成中，1分钟内生成结果！",
              type: "success",
              duration: 10000,
              showClose: true,
            });
            this.generateVisiable = true;
            // let timesRun = 0;
            // this.interval = null;
            // let interval = setInterval(() => {
            //   // timesRun++;
            //   if (this.interval != null) {
            //     clearInterval(interval);
            //   } else {
            //     let params = {
            //       reportId: this.id,
            //       queueId: result,
            //     };
            //     this.details(params);
            //   }
            // }, 10000);
            if (result.responseResultContent) {
              this.tableDatas = JSON.parse(result.responseResultContent);
              this.tableDatas = this.tableDatas.slice(0, 200);
              this.copyTableDatas = JSON.parse(
                JSON.parse(JSON.stringify(result.responseResultContent))
              );
            } else {
              // let params = {
              //   reportId: this.id,
              //   queueId: result,
              // };
              // this.details(params);

              let timesRun = 0;
              this.interval = null;
              let count = 0;
              let interval = setInterval(() => {
                // timesRun++;
                // if (this.interval != null) {
                if (this.interval != null) {
                  console.log("清空");
                  clearInterval(interval);
                } else {
                  let params = {
                    reportId: this.id,
                    queueId: result,
                  };
                  count += 1;
                  console.log("循环", count);
                  this.details(params);
                }
              }, 1000);
            }
            // let list = JSON.parse(JSON.stringify(result));
            // this.copyTableData = JSON.parse(JSON.stringify(result));
            // this.tableDatas = list.slice(0, 200);
          }
        });
      }
    },

    search() {
      if (this.tableHeader.length) {
        this.queryAnalyzeList();
      } else {
        this.$message({
          message: "请添加表头",
          type: "warning",
        });
      }
    },
    async filter() {
      console.log(this.filterArr);
      this.isValid = true;
      this.filterArr.forEach((v) => {
        if (!v.value) {
          console.log(v.column);
          this.$message({
            message: `请设置字段值：${tableXiaoji[v.column]}`,
            type: "warning",
          });
          this.isValid = false;
        }
      });
      if (!this.isValid) {
        return;
      }
      if (!this.queueId) {
        this.$message({
          message: "请生成报表后再过滤!",
          type: "warning",
        });
        return;
      }
      const { code, result } = await this.$store.dispatch(
        "querySsrAnalysisQueueFilterDetail",
        {
          filterColumnList: this.filterArr,
          queueId: this.queueId,
        }
      );
      if (code == "0") {
        if (result.responseResultContent) {
          this.tableDatas = JSON.parse(result.responseResultContent);
          this.tableDatas = this.tableDatas.slice(0, 200);
          this.copyTableDatas = JSON.parse(
            JSON.parse(JSON.stringify(result.responseResultContent))
          );
        }
        this.filterDialog = false;
      }
    },
    filterAdd(i) {
      const obj = { column: "", value: "" };
      this.filterArr.splice(i + 1, 0, obj);
    },
    filterDel(i) {
      this.filterArr.splice(i, 1);
    },
    addCol(v) {
      if (v.show) {
        this.areaClose(v);
      } else {
        if (this.col.findIndex((o) => o.id === v.id) < 0) {
          this.col.push(v);
          this.dropCol.push(v);
        }
      }

      // this.dropCol.push(v);
      // this.col = arrayUnique2(this.col, "id");
      // this.dropCol = arrayUnique2(this.dropCol, "id");
      this.tableData = [];
      // this.dropCol.push(v);
    },
    areaClose(item) {
      this.tableData = [];

      this.col.splice(
        this.col.findIndex((o) => o.id === item.id),
        1
      );
      this.dropCol.splice(
        this.dropCol.findIndex((o) => o.id === item.id),
        1
      );

      this.$forceUpdate();
    },
    // 获取表头接口
    async queryList() {
      let params = {
        pageNo: 1,
        pageSize: 9999,
        id: this.id,
      };
      const { result } = await this.$store.dispatch("queryUsePageList", params);

      const { ssrColumnsConfigModelList } = result.records[0];

      this.searchList = [];
      this.col = [];
      this.coypColList = [];
      this.tableGroup = [];

      ssrColumnsConfigModelList.forEach((v) => {
        if (v.isWhereColumn === "yes") {
          if (v.columnType === "datetime") {
            if (v.queryMode === "range") {
              if (v.datetimeRangeType !== "" && v.datetimeRangeType) {
                v.applyDate = getDayAndToday(v.datetimeRangeType);
              } else {
                v.applyDate = [];
              }
            } else {
              // v.queryValue = "";
              this.$set(v, "queryValue", "");
            }
          } else if (v.columnType === "date") {
            // v.applyDate = [];
            this.$set(v, "applyDate", "");
          } else if (v.columnType === "strings") {
            if (v.queryMode === "multiple") {
              v.isSelect = true;
              v.isMultiple = true;
              v.queryListValue = [];
              v.selectList = this.$sysAllDict[v.associatedDictCode];
            } else if (v.queryMode === "single") {
              v.isSelect = true;
              v.isMultiple = false;
              // v.queryValue = "";
              this.$set(v, "queryValue", "");
              v.selectList = this.$sysAllDict[v.associatedDictCode];
            } else {
              v.isSelect = false;
              this.$set(v, "queryValue", "");
              // v.queryValue = "";
            }
          } else if (v.columnType === "integer") {
            if (v.queryMode === "multiple") {
              v.isSelect = true;
              v.isMultiple = true;
              v.queryListValue = [];
              v.selectList = this.$sysAllDict[v.associatedDictCode];
            } else if (v.queryMode === "single") {
              v.isSelect = true;
              v.isMultiple = false;
              // v.queryValue = "";
              this.$set(v, "queryValue", "");
              v.selectList = this.$sysAllDict[v.associatedDictCode];
            } else if (v.queryMode === "range") {
              v.isSelect = false;
              // v.queryStartValue = "";
              // v.queryEndValue = "";
              this.$set(v, "queryStartValue", "");
              this.$set(v, "queryEndValue", "");
            } else {
              // v.queryValue = "";
              this.$set(v, "queryValue", "");
            }
          }

          this.searchList.push(v);
        }
        if (
          v.isSelectColumn === "yes" ||
          v.isGroupColumn === "yes" ||
          v.isAggregateColumn === "yes"
        ) {
          this.tableList.push(v);
        }

        // if (v.isSelectColumn === "yes") {
        //   this.tableList.push(v);
        //   // this.col.push(v);
        // }
        // if (v.isGroupColumn === "yes") {
        //   this.tableGroup.push(v);
        // }
      });

      this.col = JSON.parse(JSON.stringify(this.tableList));
      this.dropCol = JSON.parse(JSON.stringify(this.tableList));
      // this.tableCol = JSON.parse(JSON.stringify(this.col));
      this.coypColList = JSON.parse(JSON.stringify(this.tableList));
      this.tableData = [];

      this.tableHeader = JSON.parse(JSON.stringify(this.tableList));
      console.log("this.tablerHeader");
      console.log(this.tableHeader);
      // 小记表头数组
      this.tableHeader.forEach((v) => {
        if (v.columnType == "integer") {
          this.tableXiaoji.push(v.columnName);
        }
      });
      console.log("tableXiaoji", this.tableXiaoji);
      this.tableHeader.forEach((v) => {
        v.isShow = true;
      });

      // this.searchList.forEach((v, i) => {
      //   this.$set(this.searchList, i, v);
      // });
      this.searchList = [...this.searchList];
      console.log("this.searchList: ", this.searchList);
      this.queryNotHeader();
      this.$forceUpdate();
    },
    datefocus(i, v) {
      if (v.datetimeRangeLimit !== "") {
        this.days = v.datetimeRangeLimit;
      }

      this.$set(this.searchList, i, v);
    },
    dateblur(i, v) {
      this.$set(this.searchList, i, v);
    },
    datechange(i, v) {
      this.$set(this.searchList, i, v);
    },
    queryNotHeader() {
      this.dropCol = getSubtract(this.tableHeader, this.tableList, "id");
    },
    toggleSideBar() {
      this.isCollapse = !this.isCollapse;
    },

    columnDrop() {
      const wrapperTr = document.querySelector(".el-table__header-wrapper tr");
      this.sortable = Sortable.create(wrapperTr, {
        animation: 180,
        delay: 0,
        onEnd: (evt) => {
          const oldItem = this.col[evt.oldIndex];
          this.dropCol.splice(evt.oldIndex, 1);
          this.dropCol.splice(evt.newIndex, 0, oldItem);
          // this.col = JSON.parse(JSON.stringify(this.dropCol));
        },
      });
    },

    // 导出excel
    output() {
      if (this.tableDatas.length) {
        require.ensure([], () => {
          const { exportJsonToExcel } = require("@/utils/output/Export2Excel");

          this.isOutputing = true;
          let refTable = this.$refs.hmtable.getTable();
          const list = this.copyTableDatas;
          const tHeader = refTable.columns
            .map((o) => o.label !== "序号" && o.label)
            .filter((o) => o);
          let filterVal = [];
          if (list.length > 0) {
            filterVal = refTable.$children
              .map((o) => o._props.prop)
              .filter((o) => o);
          }

          let title = this.row.reportName;
          console.log("this.row.reportName: ", this.row);

          const data = this.formatJson(filterVal, list);
          exportJsonToExcel(tHeader, data, title + new Date().toLocaleString());
          this.isOutputing = false;
        });
      } else {
        this.$message({
          message: "请先生成报表！",
          type: "warning",
        });
      }
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    showSearchToggle() {
      this.searchListVisbale = !this.searchListVisbale;
    },
  },
};
</script>
<style lang="scss">
html * {
  scroll-behavior: auto;
}
.pivot-table {
  $enable-rounded: false;
  $table-cell-padding: 0.5rem; // default in bs5
  $table-cell-padding-sm: 0.25rem; // default in bs5
  @import "~bootstrap/scss/bootstrap.scss";

  /* Table with aria-busy attribute */
  table[aria-busy="true"] {
    opacity: 0.6;
  }

  /* FontAwesome icons */
  .svg-inline--fa.fa-fw {
    width: 1.25em;
  }

  .svg-inline--fa {
    display: inline-block;
    font-size: inherit;
    height: 1em;
    overflow: visible;
    vertical-align: -0.125em !important;
  }

  .fa-pulse {
    animation: fa-spin 1s infinite steps(8);
  }

  @keyframes fa-spin {
    0% {
      transform: rotate(0deg);
    }

    to {
      transform: rotate(1turn);
    }
  }
}

.el-button--blue {
  color: #fff;
  background-color: #0081e5;
  border-color: #0081e5;
}
.el-button--blue:hover,
.el-button--blue:focus {
  color: #fff;
  border-color: #0081e5d1;
  background-color: #0081e5d1;
}

.page-component__scroll {
  height: 100%;
}
.page-component__scroll .el-scrollbar__wrap {
  overflow-x: hidden;
}
// .diy-loading {
//   .el-loading-spinner {
//     background-image: url("https://imgcdn.hemiao100.com/ThemePictures/8C3E83446233755EFA46B6D9A35A1438.gif"); // 这个是自己想设置的 gif 加载动图
//     background-repeat: no-repeat; //设置背景 图 不重复
//     height: 100%;
//     background-position: center; //设置背景 定位  为居中
//     top: 0; //覆盖 element-ui  默认的 50%    因为此处设置了height:100%,所以不设置的话，会只显示一半，因为被top顶下去了
//   }
//   .el-loading-spinner .circular {
//     display: none; //隐藏 之前  element-ui  默认的 loading 动画
//   }
// }
</style>
<style lang="scss" scoped>
.shadow {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}
.not-add-header {
  padding: 10px 20px;
  background: #f7f7f7;
  min-height: 100px;
  .title {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 600;
    color: #222;
  }
}
.is-require {
  content: "*";
  color: #f56c6c;
  margin-right: 4px;
}
.table-name {
  width: 200px;
  display: inline-block;
}
.hamburger {
  display: block;
  cursor: pointer;
  padding: 0 10px;
  transform: rotate(90deg);
}
.hamburger.is-active {
  transform: rotate(0deg);
}
.title {
  margin-bottom: 20px;
  &::before {
    display: inline-block;
    margin-right: 10px;
    content: "";
    width: 4px;
    height: 12px;
    background: #e50065;
    border-top-left-radius: 30px;
    border-bottom-right-radius: 30px;
  }
}
.hm-table-darg {
  position: relative;
  .display {
    background: #eef1f6;
    padding: 8px 24px;
    margin-bottom: 20px;
    border-radius: 2px;
    color: #2c3e50;
  }
  // .seacrch-list {
  //   // margin-left: 50px;
  //   position: absolute;
  //   top: 50px;
  //   z-index: 999;
  // }
  .list-group-none {
    margin-left: 50px;
    position: absolute;
    top: 0;
    z-index: 999;
    opacity: 0;
  }
}
.box {
  width: 80px;
  height: 80px;
  background: url("https://imgcdn.hemiao100.com/ThemePictures/20191012183039430.png")
    no-repeat;
  background-position: left;
  background-size: cover;
  position: absolute;
  right: -10px;
  top: -10px;
  // background-size: 50px 50px;
}
.is-boxactive {
  background-position: right;
  transition: background 0.6s steps(28); //根据图片有多少帧，比如我这张图片有29张小图，那就是填28
}
.expand_search {
  width: 100%;
  height: 34px;
  text-align: center;
  line-height: 34px;
  color: #fff;
  background: #0081e5;
  .icon-xiashuangjiantou {
    position: relative;
    top: 2px;
  }
}
// 表头颜色
.el-table__header .el-table th.el-table__cell.is-leaf {
  background: #f7f7f7 !important;
}
// 添加表头按钮
.table-options {
  position: absolute;
  right: 0;
  top: 0;
  width: 40px;
  // height: 92px;
  height: 74px;
  box-sizing: border-box;
  padding: 0 10px;
  background: #fff;
  font-size: 12px;
  border: 1px solid #f7f7f7;
  cursor: pointer;
  .table-options-text {
    width: 20px;
    color: #666666;
  }
  .icon-icon-youjiantou {
    font-size: 12px;
  }
}
.table-set-popup {
  position: absolute;
  right: 0;
  top: 0;
  width: 266px;
  height: 470px;
  overflow-y: scroll;
  padding: 15px 30px;
  background: #fff;
  z-index: 2;
  box-shadow: -6px 0px 8px 0px rgba(0, 0, 0, 0.08);
  .table-set-tit {
    font-weight: bold;
    font-size: 18px;
    margin-bottom: 20px;
  }
  .table-set-close {
    position: absolute;
    right: 10px;
    top: 10px;
    cursor: pointer;
  }
  .icon-guanbi1 {
    font-size: 18px;
  }
}
.icon-jiahao,
.icon-jianhao1 {
  font-size: 24px;
}
.icon-jiahao {
  color: #d22e66;
}
.icon-jianhao1 {
  color: #909398;
}
</style>
